import React from 'react'
import { FiFilter } from "react-icons/fi";
import './FilterButton.css'

const FilterButton = ({ onClick, className }) => {
    return (
        <button className={`filterBtnBlock ${className ? className : ''}`} onClick={onClick}>
            <FiFilter className={`filterIcon ${className ? className : ''}`} />
            <div className={`filterBtn ${className ? className : ''}`}>Filter</div>
        </button>
    )
}
export default FilterButton